import { isValid, parse } from 'date-fns';
import {
  FinancialStatus,
  INoteAttribute,
  IOrder,
  IOrderAddress,
  OrderStatus,
} from '@monofront/types';
import {
  CARRIERS_MODAL_MESSAGE,
  DHL,
  ECOLOTRANS,
  FIRST_TIME_SERVICES,
} from '../constants';

export const getOrderStatus = (order: IOrder): OrderStatus => {
  const { fulfillmentStatus, cancelledAt } = order;

  if (fulfillmentStatus === 'fulfilled' || fulfillmentStatus === 'partial') {
    return OrderStatus.prepared;
  }

  if (cancelledAt) {
    return OrderStatus.cancelled;
  }

  return OrderStatus.pending;
};

export const getFinancialStatus = (
  order: IOrder,
): FinancialStatus.PARTIALLY_REFUNDED | FinancialStatus.REFUNDED | null => {
  const { financialStatus } = order;

  if (financialStatus === 'partially_refunded') {
    return FinancialStatus.PARTIALLY_REFUNDED;
  }

  if (financialStatus === 'refunded') {
    return FinancialStatus.REFUNDED;
  }

  return null;
};

export const getIsFirstTimeServices = (
  noteAttributes: INoteAttribute[],
): boolean =>
  Boolean(noteAttributes.find(({ value }) => value === FIRST_TIME_SERVICES));

export const getIsEcolotrans = (noteAttributes: INoteAttribute[]): boolean =>
  Boolean(noteAttributes.find(({ value }) => value?.startsWith(ECOLOTRANS)));

export const getIsShipUp = (noteAttributes: INoteAttribute[]): boolean =>
  Boolean(noteAttributes.find(({ value }) => value?.startsWith(DHL)));

export const getCarrierModalMessage = (noteAttributes: INoteAttribute[]) => {
  const carrier = CARRIERS_MODAL_MESSAGE.find((carrier) => {
    const hasCarrier = noteAttributes.some((note) => {
      return note.value?.startsWith(carrier.carrier);
    });

    return hasCarrier;
  });

  return carrier ? carrier.modalTextKey : null;
};

export const getInlineDeliveryAddress = (address: IOrderAddress): string =>
  `${address.address1}, ${address.zip} ${address.city}`;

export const getDeliveryDate = (
  noteAttributes: INoteAttribute[],
): Date | null => {
  const deliveryDateAttribute = noteAttributes.find(
    (note) => note.name === 'delivery_date',
  );

  if (!deliveryDateAttribute?.value) return null;

  const deliveryDate = parse(
    deliveryDateAttribute.value,
    'yyyy/MM/dd',
    new Date(),
  );

  return isValid(deliveryDate) ? deliveryDate : null;
};

export const getDeliverySlot = (
  noteAttributes: INoteAttribute[],
): string | null => {
  const deliverySlotAttribute = noteAttributes.find(
    (note) => note.name === 'delivery_time_slot',
  );

  if (!deliverySlotAttribute?.value) return null;

  return deliverySlotAttribute.value.replace(/\s/g, '');
};
